import React from "react";

export const FormGroup = ({ children, ...props }) => {
  return (
    <div className="form-group" {...props}>
      {children}
    </div>
  );
};
